import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Select, Input, DateInput } from "@components/form";
import { useIntegration } from "@hooks";

const IntegrationSearch = ({ defaultValues, onSearch }) => {
  // hook 에서 옵션 데이터(categoryList, eduTypeList)만 가져옴
  const { categoryList, eduTypeList, resetSearch, } = useIntegration();

  const methods = useForm({ defaultValues });
  const { handleSubmit, watch, reset } = methods;
  const watchStart = watch("srcStartDate");

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSearch)}>
        <div className="search-wrap">
          <div className="search-row">
            <div className="search-item">
            <label>강의분류</label>
            <Select
              name="eduCategoryId"
              options={categoryList?.result}
              valueKey="eduCategoryId"
              labelKey="eduCategoryNm"
              defaultOption="전체"
              className="input-select"
            />

            <label style={{ marginLeft: "10px" }}>강의유형</label>
            <Select
              name="eduType"
              options={eduTypeList?.result}
              valueKey="comdCode"
              labelKey="comdName"
              defaultOption="전체"
              className="input-select"
            />

            <label style={{ marginLeft: "10px" }}>강의날짜</label>
            <DateInput name="srcStartDate" className="wd120"/>
            <span className="separator">~</span>
            <DateInput name="srcEndDate" minDate={watchStart} className="wd120"  />

            <label style={{ marginLeft: "10px" }}>조회조건</label>
            <Select
              name="searchCnd"
              options={[
                { key: "0", name: "강의명" },
                { key: "1", name: "소속회사" },
                { key: "2", name: "아이디" },
                { key: "3", name: "이름" },
              ]}
              defaultOption="전체"
              className="input-select"
            />
              <Input
                name="searchWrd"
                placeholder="검색어를 입력하세요"
                className="input-search"
                style={{ width: "200px" }}
              />
            </div>

            <div className="search-btn-container">
              <button type="submit" className="btn-search">조회</button>
              <button type="button" className="btn-reset" 
                 onClick={() => {
                  if (!window.confirm("조회 조건을 초기화 하시겠습니까?")) return;
                  reset(defaultValues); 
                  resetSearch(); 
                }}>초기화</button>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default IntegrationSearch;
